// @ts-check
import SwishStatsModel from "./swish-stats-model";

export default class SwishPlayerStatsModel extends SwishStatsModel {
  /**
   * @param {import('./interface').TSwishStats} data - raw data
   */
  constructor(data) {
    super(data);
    /**
     * Full name of the player
     * @type {string}
     */
    this.fullName = data.pl;
    /**
     * Match player ID
     * @type {number}
     */
    this.matchPlayerId = data.mpid;
    /**
     * Swish player ID
     * @type {number}
     */
    this.playerId = data.sp;
  }
}